import { Segment } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';

const Sidebar = ({ data, block, onChangeBlock, openObjectBrowser }) => {
  const intl = useIntl();
  return (
    <Segment.Group raised key={block.id || block}>
      <header className="header pulled">
        <h2>{intl.formatMessage(messages.event_program_block)}</h2>
      </header>
      <div className="block-description">
        {intl.formatMessage(messages.event_program_block_description)}
      </div>
    </Segment.Group>
  );
};
export default Sidebar;

const messages = defineMessages({
  event_program_block: {
    id: 'event_program_block',
    defaultMessage: 'Programma evento',
  },
  event_program_block_description: {
    id: 'event_program_block_description',
    defaultMessage:
      "Questo blocco si compila automaticamente con il testo inserito nel campo 'Scrivi il programma dell'evento' del CT Evento",
  },
});
